import About from "."; 

export const aboutRoutes = () => [
  {
    path: "/about",
    component: About,
    layout: "front",
    title: "page",
  },
];